import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { PaginatedResultModel } from '@app/data-layer/models/common';
import { FavoriteHtsNumberModel } from '@app/data-layer/models/common/favorite-hts-number.model';
import { enumBinaCatalogItemType } from '@enum/enumBinaCatalogItemType';
import { Observable } from 'rxjs';

@Component({
  selector: 'app-bina-catalog-list',
  templateUrl: './bina-catalog-list.component.html',
  styleUrls: ['./bina-catalog-list.component.scss'],
})
export class BinaCatalogListComponent implements OnInit {
  @Input() public catalogList: Observable<PaginatedResultModel<FavoriteHtsNumberModel>>;
  @Input() public isLoading: boolean = false;
  @Input() public paginationListId: string;
  @Input() public total: number;
  @Input() public limit: number;
  @Input() public totalRows: number;
  @Input() public page: number = 1;
  @Input() public paginationMaxSize: number;
  @Output() public pageChanged: EventEmitter<number> = new EventEmitter<number>();
  @Output() public limitChanged: EventEmitter<number> = new EventEmitter<number>();
  @Output() public deleteItem: EventEmitter<number> = new EventEmitter<number>();
  @Output() public openCalculator: EventEmitter<FavoriteHtsNumberModel> = new EventEmitter<FavoriteHtsNumberModel>();
  @Output() public reclassify: EventEmitter<{ existingDescription: string; itemIdToDelete: number }> = new EventEmitter<{
    existingDescription: string;
    itemIdToDelete: number;
  }>();
  @Output() public history: EventEmitter<number> = new EventEmitter<number>();

  public enumBinaCatalogItemType: typeof enumBinaCatalogItemType = enumBinaCatalogItemType;

  constructor() {}

  ngOnInit(): void {}

  public onPageChange(page: number): void {
    this.page = page;
    this.pageChanged.emit(page);
  }
}
